export function postRedirect(url: string): void {
  const form = document.createElement('form');
  form.method = 'post';
  form.action = url;

  document.body.append(form);

  form.submit();
}
